export function limitStrLen(str, desiredLength) {
  if (str.length <= desiredLength) return str;
  return str.slice(0, desiredLength) + "...";
}

export function capitalize(str) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}
